import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { sizes } from '../../../const/sizes';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { NormalInputBase } from '../NormalInputBase';
import { Select } from '../Select/Select/Select';
import { usePhoneNumberInput } from './usePhoneNumberInput';
export const DEFAULT_CZECH_PHONE_NUMBER_PREFIX = '+420';
const PHONE_INPUT_WIDTH = sizes.phoneNumberInput.phoneInputWidth;
const SELECT_PREFIX_MIN_WIDTH = sizes.phoneNumberInput.selectPrefixMinWidth;
export const PhoneNumberInput = forwardRef(({ phonePrefixes = [DEFAULT_CZECH_PHONE_NUMBER_PREFIX], phonePrefix = '', phoneNumberWithoutPrefix = '', maxPhoneCharacterCount, prefixLabel, onValueChange, readOnly, required, isRequiredLabel, disabled, autoComplete, prefixPlaceholder, prefixTestId, prefixError, ...inputPhoneProps }, ref) => {
    const { prefix, handleChange, handleChangePrefix } = usePhoneNumberInput({
        phonePrefix,
        phoneNumberWithoutPrefix,
        maxPhoneCharacterCount,
        onValueChange,
    });
    const prefixOptions = phonePrefixes.map((prefixValue) => ({
        text: prefixValue,
        value: prefixValue,
        testId: prefixValue,
    }));
    const commonProps = {
        readOnly,
        required,
        isRequiredLabel,
        disabled,
        autoComplete,
    };
    return (_jsxs(FlexContainer, { gap: true, children: [_jsx(Box, { minWidth: SELECT_PREFIX_MIN_WIDTH, children: _jsx(Select, { ...commonProps, label: prefixLabel, options: prefixOptions, value: prefix, placeholder: prefixPlaceholder, error: prefixError, testId: prefixTestId, onValueChange: handleChangePrefix }) }), _jsx(Box, { width: PHONE_INPUT_WIDTH, children: _jsx(NormalInputBase, { ref: ref, ...commonProps, ...inputPhoneProps, type: 'tel', value: phoneNumberWithoutPrefix, onChange: handleChange }) })] }));
});
